export async function useGlightbox(target: string) {
  if (!target) return
  const { default: GLightbox } = await import('glightbox')
  // @ts-ignore
  await import('glightbox/dist/css/glightbox.css').then(({ default: css }) => css)
  const lightbox = GLightbox({})
  return lightbox
}